"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _Title.default;
  }
});
Object.defineProperty(exports, "SubTitle", {
  enumerable: true,
  get: function get() {
    return _SubTitle.default;
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _Text.default;
  }
});
Object.defineProperty(exports, "TextBold", {
  enumerable: true,
  get: function get() {
    return _TextBold.default;
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label.default;
  }
});
Object.defineProperty(exports, "SubLabel", {
  enumerable: true,
  get: function get() {
    return _SubLabel.default;
  }
});
Object.defineProperty(exports, "BorderedTitle", {
  enumerable: true,
  get: function get() {
    return _BorderedTitle.default;
  }
});
Object.defineProperty(exports, "H1", {
  enumerable: true,
  get: function get() {
    return _H.default;
  }
});
Object.defineProperty(exports, "H2", {
  enumerable: true,
  get: function get() {
    return _H2.default;
  }
});
Object.defineProperty(exports, "H3", {
  enumerable: true,
  get: function get() {
    return _H3.default;
  }
});
Object.defineProperty(exports, "H4", {
  enumerable: true,
  get: function get() {
    return _H4.default;
  }
});
Object.defineProperty(exports, "Body", {
  enumerable: true,
  get: function get() {
    return _Body.default;
  }
});
Object.defineProperty(exports, "DataBlock", {
  enumerable: true,
  get: function get() {
    return _DataBlock.default;
  }
});

var _Title = _interopRequireDefault(require("./Title"));

var _SubTitle = _interopRequireDefault(require("./SubTitle"));

var _Text = _interopRequireDefault(require("./Text"));

var _TextBold = _interopRequireDefault(require("./TextBold"));

var _Label = _interopRequireDefault(require("./Label"));

var _SubLabel = _interopRequireDefault(require("./SubLabel"));

var _BorderedTitle = _interopRequireDefault(require("./BorderedTitle"));

var _H = _interopRequireDefault(require("./H1"));

var _H2 = _interopRequireDefault(require("./H2"));

var _H3 = _interopRequireDefault(require("./H3"));

var _H4 = _interopRequireDefault(require("./H4"));

var _Body = _interopRequireDefault(require("./Body"));

var _DataBlock = _interopRequireDefault(require("./DataBlock"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }